/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from 'react'
import {
  Header,
  Footer,
  Link_Box3,
  Search_Box1,
  Loading,
  Paginate,
} from '../../../components/index'
import { WebApi } from '../../../api/web'

const ServiceList = () => {
  const [consultingList, setConsultingList] = useState(null)
  const [valueSearch, setValueSearch] = useState('')
  const [totalPage, setTotalPage] = useState(1)
  const [page, setPage] = useState(1)

  useEffect(() => {
    Consultinglist()
  }, [page])

  const Consultinglist = async () => {
    await WebApi.consultingList(page)
      .then((res) => {
        setConsultingList(res.data.data.consultingList.consultings)
      })
      .catch((err) => {})
  }
  const setLink = (data) => {
    if (data.reserveTime.date) {
      return `/profile-lawyer/${data._id}`
    } else {
      return `/calendar/${data.lawyer._id}`
    }
  }

  return (
    <>
      <Header title='خدمات درحال انجام' />
      <div className='container'>
        <div className='template-pages'>
          {consultingList ? (
            consultingList.length > 0 ? (
              <>
                <Search_Box1 placeholder='نام وکیل' setState={setValueSearch} />
                {consultingList
                  .filter((data) => {
                    return (
                      (data.lawyer.fname.includes(valueSearch) ||
                        data.lawyer.lname.includes(valueSearch)) &&
                      (data.status == 3 ||
                        data.status == 2 ||
                        (!data.reserveTime.date && data.status != 1))
                    )
                  })
                  .map((Data, index) => (
                    <Link_Box3
                      key={index}
                      data={Data}
                      job='وکیل پایه یک دادگستری'
                      link={setLink(Data)}
                    />
                  ))}
                <Paginate {...{ totalPage, page, setPage }} />
              </>
            ) : (
              <h5 className='empty-alert'>هیچ سرویسی ثبت نشده!</h5>
            )
          ) : (
            <Loading />
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}
export default ServiceList
